import React, { useMemo, forwardRef } from "react";
import styled, { keyframes } from "styled-components";
import { FaRegLightbulb } from "react-icons/fa";
import { getTitle } from "app/common/utils/Logo";

const FloatingChatButton = forwardRef((props, ref) => {
  const title = useMemo(() => `${getTitle()} AI`, []);

  const renderFloatingChatButton = () => {
    return (
      <Container>
        <StyledButton {...props} ref={ref}>
          <FaRegLightbulb />
          <ChatText>{title}</ChatText>
        </StyledButton>
      </Container>
    );
  };

  return renderFloatingChatButton();
});

export default FloatingChatButton;

const Container = styled.div`
  display: flex;
  position: fixed;
  right: -50px;
  top: 50%;
  transform: rotate(-90deg);
  translate: transform(-50%);
  z-index: 999;
`;

const ChatText = styled.div`
  && {
    padding: 0 0.5rem;
  }
`;

const moveGradientKeyframe = keyframes`
50% {
  background-position: 100% 50%;
}
`;
const StyledButton = styled.button`
  --border-width: 2px;
  --border-radius: 12px;
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);
  color: rgb(238, 238, 238);
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 14px;
  border: none;
  position: relative;
  padding: 0.5rem 1rem;

  &::after {
    position: absolute;
    content: "";
    top: calc(-1 * var(--border-width));
    left: calc(-1 * var(--border-width));
    z-index: -1;
    width: calc(100% + var(--border-width) * 2);
    height: calc(100% + var(--border-width) * 2);
    background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
    background-size: 300% 300%;
    background-position: 0 50%;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    animation: ${moveGradientKeyframe} 4s alternate infinite;
  }
`;
